import {Observable, throwError} from 'rxjs';
import { isNullOrUndefined } from 'util';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, filter, map } from 'rxjs/operators';

import {
    DraftRequete, DraftRequeteSummary, Juridiction, Justificatifs, PartieDepotDraft, RequeteContentieuxSocial
} from '../../entities/draft-requete/draft-requete.model';
import { HttpCodeEnum } from '../constants/http-code.constants';
import { ContentieuxSocial } from '../../entities/contentieux-social';

@Injectable()
export class DraftRequeteService {
    private resourceUrl = '/api/my-draft-requete';

    constructor(private http: HttpClient) {}

    initMyDraftRequete(): Observable<DraftRequete> {
        return this.http
            .post<DraftRequete>(this.resourceUrl, null).pipe(
                map(draft => DraftRequete.castAs(draft)))
    }

    getMyDraftRequeteDetail(): Observable<DraftRequete | any> {
        return this.http.get<DraftRequete>(this.resourceUrl).pipe(
            filter(draft => !isNullOrUndefined(draft)),
            map(draft => DraftRequete.castAs(draft)),
            catchError((err) => {
                if (err.status === HttpCodeEnum.NOT_FOUND) {
                    return null;
                }
                throwError(err);
            })
        );
    }

    getMyDraftRequeteSummary(): Observable<DraftRequeteSummary | any> {
        return this.http
            .get<DraftRequeteSummary>(`${this.resourceUrl}/summary`)
            .pipe(
                catchError((err) => {
                    if (err.status === HttpCodeEnum.NOT_FOUND) {
                        return null;
                    }
                    throw err;
                })
            );
    }

    deleteMyDraftRequete() {
        return this.http.delete(this.resourceUrl);
    }

    addOneRequerant() {
        return this.http.patch(`${this.resourceUrl}/requerants/add-one-requerant`, null);
    }

    addRequerants(requerants: PartieDepotDraft[]) {
        return this.http.patch(`${this.resourceUrl}/requerants/add-many-requerants`, requerants);
    }

    addMandants(requerants: PartieDepotDraft[]) {
        return this.http.patch(`${this.resourceUrl}/requerants/add-mandants`, requerants);
    }

    addJuridiction(juridiction: Juridiction) {
        return this.http.patch(`${this.resourceUrl}/juridictions/add-juridiction`, juridiction);
    }

    addNormalProceedingRequest(requeteContentieuxSocial: RequeteContentieuxSocial) {
        console.log('addRequete requeteContentieuxSocial :', requeteContentieuxSocial);
        return this.http.patch(`${this.resourceUrl}/requete/add-normal-proceeding-request`, requeteContentieuxSocial);
    }

    addInterimProceedingRequest(typeRequeteId: number) {
        console.log('addInterimProceedingRequest typeRequeteId :', typeRequeteId);
        return this.http.patch(`${this.resourceUrl}/requete/add-interim-proceeding-request`, typeRequeteId);
    }

    addJustificatifs(justification: Justificatifs) {
        return this.http.patch(`${this.resourceUrl}/justificatifs/add-justificatifs`, justification);
    }

    addRecapitulatif() {
        return this.http.patch(`${this.resourceUrl}/recapitulatifs/add-recapitulatif`, null);
    }

    depotRequete() {
        return this.http.post(`${this.resourceUrl}/depot`, null);
    }

    getContentieuxSocial(contentieuxSocialId: number): Observable<ContentieuxSocial | any> {
        return this.http.get<ContentieuxSocial>(`${this.resourceUrl}/requete/get-contentieux-social-by-id/${contentieuxSocialId}`, {
            responseType: 'json'
        }).pipe(
            catchError((err) => {
                if (err.status === HttpCodeEnum.NOT_FOUND) {
                    return null;
                }
                throw err;
            })
        );
    }

    public generateInventairePreview(): Observable<Blob> {
        return this.http
            .get(`${this.resourceUrl}/inventaires/preview`, {
                responseType: 'blob'
            });
    }

    public downloadJustificatif(fileApiId: string): Observable<Blob> {
        return this.http
            .get(`${this.resourceUrl}/pieces/${fileApiId}/download`, {
                responseType: 'blob'
            });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/draft-requete.service.ts